import style from "./TableBody.module.scss";
import { useAppSelector } from "store/hooks";
import { useGetAllCostsQuery } from "@RTKQuery/admin/cost/cost";
import { ICost } from "@interfaces/admin/сost";

export function TableBody({
    children
}: {
    children: (data: ICost) => JSX.Element
}) {
    const {activeEndDate, activeStartDate, activePaginationPage, activeTagFilter} = useAppSelector(state => state.costsAdminPage);

    const { data } = useGetAllCostsQuery({
        page: activePaginationPage,
        end_date: activeEndDate,
        start_date: activeStartDate,
        tag_id: activeTagFilter
    });

    return (
        <div className={style.body}>
            {
                data?.costs.map(row => children(row))
            }
        </div>
    )
}

